import { FormControl, FormGroup, Validators } from "@angular/forms";

export class MailTemplateModel {
  mailTemplateId: number;
  default: boolean;
  templateName: string;
  subject: string;
  emailBodyText: string;
  smsBodyText: string;

  static asFormGroup(template: MailTemplateModel): FormGroup {
    const fg = new FormGroup({
      templateName: new FormControl(template?.templateName, [Validators.required]),
      default: new FormControl(template?.default),
      subject: new FormControl(template?.subject),
      emailBodyText: new FormControl(template?.emailBodyText),
      smsBodyText: new FormControl(template?.smsBodyText),
    });
    return fg;
  }
}
